import axios from "axios";
import { ApiCreatePresignedUrl } from "../presigned";

// Función para subir un archivo
export const uploadFile = async (file, setProgress, folder) => {
  const currentDate = Date.now();
  const name = file.name.split(".").slice(0, -1).join(".");
  const cleanName = cleanFileName(name);

  const extension = file.name.split(".").pop();
  let raiz = folder ? `sgdinner/${folder}/` : `sgdinner/`;

  const key = `${raiz}${cleanName}-${currentDate}.${extension}`;

  try {
    const res = await ApiCreatePresignedUrl(key);
    console.warn("res::::::::::", res);

    //console.log("🚀 ~ uploadFile ~ ApiCreatePresignedUrl ~ res", res);

    if (res.sms === "err") {
      return {
        success: false,
        message: "Error al generar URL prefirmada: " + res.mensaje,
      };
    }

    const { url, fields } = res.data;
    /*  const formData = new FormData();
    Object.keys(fields).forEach((key) => {
      formData.append(key, fields[key]);
    });
    formData.append("file", file); */
    // Enviar el archivo al servidor de S3
    await axios.put(url, file, {
      headers: {
        "Content-Type": file.type,
      },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress({
          status: true,
          progress: progress,
          file: file.name,
        });
      },
    });

    return {
      success: true,
      message: "Archivo subido correctamente.",
      key: key,
    };
  } catch (error) {
    console.error("❌ ~ uploadFile ~ error", error);
    return {
      success: false,
      message: "Error al subir el archivo: " + error.message,
    };
  }
};

const cleanFileName = (fileName) => {
  const regex = /[^\w\-.]/g; // Elimina todos los caracteres excepto letras, números, guiones, puntos y guiones bajos
  return fileName.replace(regex, "");
};
